import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */'./views/Home.vue')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import(/* webpackChunkName: "news" */ './views/News.vue'),
    },
    {
      path: '/newsdetails/:id',
      name: 'newsdetails',
      component: () => import(/* webpackChunkName: "news" */ './views/NewsDetails.vue'),
    },
    {
      path: '/product',
      name: 'product',
      component: () => import(/* webpackChunkName: "product" */ './views/Product.vue'),
    },
    {
      path: '/case',
      name: 'case',
      component: () => import(/* webpackChunkName: "case" */ './views/Case.vue')
    },
    {
      path: '/casedetails/:id',
      name: 'casedetails',
      component: () => import(/* webpackChunkName: "case" */ './views/CaseDetails.vue')
    },
    {
      path: '/goin',
      name: 'goin',
      component: () => import(/* webpackChunkName: "goin" */'./views/GoIn.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/admin',
      name: 'admin',
      meta: {
        requireAuth: true
      },
      component: () => import(/* webpackChunkName: "adminUser" */'./views/Admin.vue'),
      children: [{
          path: '/admin/user',
          name: 'user',
          component: () => import(/* webpackChunkName: "adminUser" */'./views/Admin/User.vue')
        },
        {
          path: '/admin/product',
          name: 'product',
          component: () => import(/* webpackChunkName: "adminProduct" */'./views/Admin/Product.vue')
        },
        {
          path: '/admin/news',
          name: 'new',
          component: () => import(/* webpackChunkName: "adminNews" */'./views/Admin/News.vue')
        },
        {
          path: '/admin/cases',
          name: 'cases',
          component: () => import(/* webpackChunkName: "adminCase" */'./views/Admin/Cases.vue')
        },
        {
          path: '/admin/team',
          name: 'team',
          component: () => import(/* webpackChunkName: "adminTeam" */'./views/Admin/Team.vue')
        },
        {
          path: '/admin/course',
          name: 'course',
          component: () => import(/* webpackChunkName: "adminCase" */'./views/Admin/Course.vue')
        },
        {
          path: '/admin/enterprise',
          name: 'enterprise',
          component: () => import(/* webpackChunkName: "adminEnterprise" */'./views/Admin/Enterprise.vue')
        },
        {
          path: '/admin/honor',
          name: 'honor',
          component: () => import(/* webpackChunkName: "adminHonor" */'./views/Admin/Honor.vue')
        },
        {
          path: '/admin/dictionary',
          name: 'dictionary',
          component: () => import(/* webpackChunkName: "adminDict" */'./views/Admin/Dictionary.vue')
        }
      ]
    }
  ]
})

// 判断是否需要登录权限 以及是否登录
router.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem('token')) {
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

export default router